import {API_BASE_URL} from "../../config/constants";
import { postRequest } from '../API'
/*********************************************************
* Function Name : list
* Description   : Get list of due users 
* By            : Afsar Ali
* Date          : 28-11-2024 
*********************************************************/
export const list = async (options) =>{
    try {
        const params = {
            url : `${API_BASE_URL}v1/admin/account/agents/list`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result, count: res?.data?.response?.count,};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : addEdit
* Description   : Get list of due users 
* By            : Afsar Ali
* Date          : 28-11-2024 
*********************************************************/
export const addEdit = async (options) =>{
    try {
        const params = {
            url : `${API_BASE_URL}v1/admin/account/agents/addeditdata`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result, count: res?.data?.response?.count,};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : changeStatus
* Description   : Get list of due users 
* By            : Afsar Ali
* Date          : 28-11-2024 
*********************************************************/
export const changeStatus = async (options) =>{
    try {
        const params = {
            url : `${API_BASE_URL}v1/admin/account/agents/change-status`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result, count: res?.data?.response?.count,};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : collectAmount
* Description   : 
* By            : Afsar Ali
* Date          : 31-05-2025
*********************************************************/
export const collectAmount = async (options) =>{
    try {
        const params = {
            url : `${API_BASE_URL}v1/admin/account/agents/collect-due`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result, count: res?.data?.response?.count,};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : settleAmount
* Description   : 
* By            : Afsar Ali
* Date          : 31-05-2025
*********************************************************/
export const settleAmount = async (options) =>{
    try {
        const params = {
            url : `${API_BASE_URL}v1/admin/account/agents/settle-due`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result, count: res?.data?.response?.count,};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function
